export default __webpack_public_path__ + "static/media/employees.7bc31902.png";